import * as H from "history";

export const goto = (history: H.History, path: H.Path | string, state?: H.LocationState) => (): void => {
  history.push(path, state);
};
